




































































































































import Vue from 'vue';
import { Lesson, Skill } from '@/store/types';
import LearningTools from '@/tools/learning';
import UserTools from '@/tools/user';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  name: 'Lessons',
  async mounted(): Promise<void> {
    if (!this.$route.query.noInit) {
      await Promise.all([
        LearningTools.loadLessons(this.$store),
        UserTools.saveLevelAsStarted(this.$store),
        UserTools.saveUnitAsStarted(this.$store),
      ]);
    }
    this.$store.commit('setMainLoading', false);
  },
  methods: {
    onLesson(lesson: Lesson): void {
      this.$store.commit('setLesson', lesson);
      this.$router.push(RoutePaths.AUDIO);
    },
    onQuizzes(lesson: Lesson): void {
      this.$store.commit('setLesson', lesson);
      this.$router.push(RoutePaths.QUIZZES);
    },
    onFlashcards(lesson: Lesson): void {
      this.$store.commit('setLesson', lesson);
      this.$router.push(RoutePaths.DRILL_FLASHCARDS);
    },
    onPronunciationAnalysis(lesson: Lesson): void {
      this.$store.commit('setLesson', lesson);
      this.$router.push(RoutePaths.DRILL_PRONUNCIATIONANALYSIS);
    },
    onVoiceComparison(lesson: Lesson): void {
      this.$store.commit('setLesson', lesson);
      this.$router.push(RoutePaths.DRILL_VOICECOMPARISON);
    },
    onVideo(lesson: Lesson): void {
      if (this.$store.getters.isPremiumUser) {
        this.$store.commit('setLesson', lesson);
        this.$router.push(RoutePaths.DRILL_VIDEO);
      } else {
        this.$store.commit('setMobileLinksPopup', true);
      }
    },
    getDifficultyLabel(lesson: Lesson) {
      if (!this.$store.state.personalizedCourse && lesson.lexicalDifficulty) {
        if (lesson.lexicalDifficulty <= 1.3) {
          const skill = this.$store.state.skills.find((item: Skill) => item.order === 1);
          return skill ? skill.label : null;
        }
        if (lesson.lexicalDifficulty <= 2.7) {
          const skill = this.$store.state.skills.find((item: Skill) => item.order === 2);
          return skill ? skill.label : null;
        }
        const skill = this.$store.state.skills.find((item: Skill) => item.order === 3);
        return skill ? skill.label : null;
      }
      return null;
    },
  },
});

